import type { ViewStyle } from 'tamagui';

export const Animations = {
    FadeIn: {
        enterStyle: { opacity: 0 },
        animation: 'quick',
    } satisfies ViewStyle,

    FadeInSlow: {
        enterStyle: { opacity: 0 },
        animation: 'slow',
    } satisfies ViewStyle,

    FadeInFromAbove: {
        transform: [{ translateY: 0 }],
        enterStyle: {
            opacity: 0,
            transform: [{ translateY: -20 }],
        },
        animation: 'quick',
    } satisfies ViewStyle,

    FadeInFromBelow: {
        transform: [{ translateY: 0 }],
        enterStyle: {
            opacity: 0,
            transform: [{ translateY: 20 }],
        },
        animation: 'quick',
    } satisfies ViewStyle,

    SlowlyFadeInFromBelow: {
        transform: [{ translateY: 0 }, { scale: 1 }],
        enterStyle: {
            opacity: 0,
            transform: [{ translateY: 50 }, { scale: 0.99 }],
        },
        exitStyle: {
            opacity: 0,
            transform: [{ translateY: -50 }, { scale: 0.95 }],
        },
        animation: 'lazy',
        animateOnly: ['opacity', 'transform'],
    } satisfies ViewStyle,
} as const;

export type AnimationsLib = typeof Animations;
